import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import {
  LiveTvOutlined,
  CheckCircleOutlineOutlined,
  ScheduleOutlined,
} from "@mui/icons-material";
import StatsCard from "../../bookings/list-booking2/StatsCard";
import apiService from "../../../service/Api";

interface StreamStats {
  total: number;
  fulfilled: number;
  cancelled: number;
}

const StatsSection: React.FC = () => {
  const [stats, setStats] = useState<StreamStats>({
    total: 0,
    fulfilled: 0,
    cancelled: 0,
  });

  const fetchStats = useCallback(async () => {
    try {
      const response = await apiService.get<StreamStats>(
        "/api/streams/stream/statistics/",
      );
      setStats({
        total: response.data.total ?? 0,
        fulfilled: response.data.fulfilled ?? 0,
        cancelled: response.data.cancelled ?? 0,
      });
    } catch (error) {
      console.error("Failed to fetch stream statistics:", error);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
      <StatsCard
        title="Total Streams"
        value={stats.total}
        icon={<LiveTvOutlined />}
        backgroundColor="#4285F4"
      />
      <StatsCard
        title="Streams Completed"
        value={stats.fulfilled}
        icon={<CheckCircleOutlineOutlined />}
        backgroundColor="#34A853"
      />
      <StatsCard
        title="Streams Cancelled"
        value={stats.cancelled}
        icon={<ScheduleOutlined />}
        backgroundColor="#f2bcbc"
      />
    </Box>
  );
};

export default StatsSection;
